import { getField } from 'vuex-map-fields';

export default {
  authenticated: state => state.authenticated,
  userLoaded: state => state.userLoaded,
  available: state => state.available,
  id: state => state.id,
  lastUserId: state => state.lastUserId,
  name: state => state.name,
  firstName: state => state.firstName,
  lastName: state => state.lastName,
  avatar: state => state.avatar,
  card: state => state.card,
  plan: state => state.plan,
  userSettingsLoading: state => state.userSettingsLoading,
  settings: state => state.settings,
  settingsUpdated: state => state.settingsUpdated,
  invitationAccepted: state => state.invitationAccepted,
  passwordResetSent: state => state.passwordResetSent,
  oneSignalIdAdded: state => state.oneSignalIdAdded,
  oneSignalIdRemoved: state => state.oneSignalIdRemoved,
  userSignedOut: state => state.userSignedOut,
  successUpdate: state => state.successUpdate,
  paymentCardChanged: state => state.paymentCardChanged,
  successEmailUpdate: state => state.successEmailUpdate,
  successPasswordUpdate: state => state.successPasswordUpdate,
  successPhoneUpdate: state => state.successPhoneUpdate,
  apiError: state => state.apiError,
  checkingPassword: state => state.checkingPassword,
  phoneVerified: state => state.phoneVerified,
  phoneVerifyFinished: state => state.phoneVerifyFinished,
  deletingPhoneInProgress: state => state.deletingPhoneInProgress,
  phone: state => state.phone,
  phoneCountryCode: state => state.phoneCountryCode,
  email: state => state.email,
  invitationsAccepted: state => state.invitations_accepted,
  userPermissions: state => state.permissions,
  region: state => state.region,
  role: state => state.role,
  incognito: (state, getters, rootState, rootGetters) => rootGetters['organisation/currentOrganisation'].id && state.incognito && state.incognito.includes(rootGetters['organisation/currentOrganisation'].id),
  permissionDenied: state => state.permissionDenied,
  getField,
};
